import React from 'react';
import Select from 'react-select';

type Option = {
    label: string;
    value: string;
}

type AtomicDropdownProps = {
    value: string;
    placeholder: string;
    options: Option[];
    errorMessage?: string;
}

const arrowDown = '<svg height="20" width="20" viewBox="0 0 20 20" aria-hidden="true" focusable="false" class="css-tj5bde-Svg"><path d="M4.516 7.548c0.436-0.446 1.043-0.481 1.576 0l3.908 3.747 3.908-3.747c0.533-0.481 1.141-0.446 1.574 0 0.436 0.445 0.408 1.197 0 1.615-0.406 0.418-4.695 4.502-4.695 4.502-0.217 0.223-0.502 0.335-0.787 0.335s-0.57-0.112-0.789-0.335c0 0-4.287-4.084-4.695-4.502s-0.436-1.17 0-1.615z"></path></svg>';

const AtomicDropdown: React.FC<AtomicDropdownProps> = (props): JSX.Element => {
    const { value, placeholder = 'Clique para Escolher', options, errorMessage, ...otherProps } = props;

    const selected = value ? options.filter((option: Option) => option.value === value)[0] : null;

    return (
        <>
            <div className="simple-dropdown-wrapper">
                <span className="select-arrow-down" dangerouslySetInnerHTML={{ __html: arrowDown }} />
                <select required {...otherProps} className="d-block d-sm-none mobile-select">
                    <option disabled defaultValue="">{ placeholder }</option>
                    {
                        options.map((option: Option) => (
                            <option
                                key={option.value}
                                selected={value && value === option.value}
                                defaultValue={option.value}
                            >
                                { option.label }
                            </option>
                        ))
                    }
                </select>
            </div>

            <Select
                defaultValue={selected}
                placeholder={placeholder}
                options={options}
                isSearchable={false}
                noOptionsMessage={() => "opção não encontrada"}
                {...otherProps}
            />
            { errorMessage && (
                <div className="error-field-message">{ errorMessage }</div>
            ) }
        </>
    );
}

export default AtomicDropdown;
